export default __webpack_public_path__ + "static/media/notification-announcement-icon.b926850d.svg";